import config from "@/config";
import { HasuraClient } from '@jupiter/ts-monorepo';

export async function getHasuraClient() {
    const _token = getToken();
    let _role = 'public';
    if (_token) {
        _role = getUserTopRole();
    }

    const _hasuraOptions = {
        role: _role,
        uri: config.hasura.uri
    };
    if (_token) {
        _hasuraOptions.token = _token;
    }
    return await new HasuraClient(_hasuraOptions).getApolloClient();
}